import { render } from "./TargetComponent.vue?vue&type=template&id=c245b91c"
import script from "./TargetComponent.vue?vue&type=script&lang=js"
export * from "./TargetComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__